import { motion } from "framer-motion";
import {
  Radar,
  RadarChart as RRadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from "recharts";

export const RADAR_DATA = [
  { dim: "Negócio", valor: 72 },
  { dim: "Marca", valor: 58 },
  { dim: "Cliente", valor: 61 },
  { dim: "Mercado", valor: 48 },
  { dim: "Marketing", valor: 66 },
];

export const Radar4D = ({ data = RADAR_DATA, caption = "Radar estratégico · Exemplo ilustrativo" }) => (
  <div data-testid="radar-chart" className="relative">
    <ResponsiveContainer width="100%" height={380}>
      <RRadarChart data={data} outerRadius="70%">
        <PolarGrid stroke="rgba(255,255,255,0.12)" />
        <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
        <PolarAngleAxis
          dataKey="dim"
          tick={{ fill: "#A9B0C2", fontSize: 11, fontFamily: "JetBrains Mono", letterSpacing: 1 }}
        />
        <Radar
          dataKey="valor"
          stroke="#E8491F"
          fill="#E8491F"
          fillOpacity={0.2}
          strokeWidth={2}
          dot={{ r: 3, fill: "#C81E64", strokeWidth: 0 }}
          isAnimationActive
        />
      </RRadarChart>
    </ResponsiveContainer>
    <p className="mt-2 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
      {caption}
    </p>
  </div>
);

export const ScoreBars = ({ data = RADAR_DATA, caption = "Índice de maturidade 0–100 · Exemplo ilustrativo" }) => (
  <div data-testid="radar-score-bars" className="space-y-5">
    {data.map((d, i) => (
      <div key={d.dim}>
        <div className="mb-2 flex items-baseline justify-between">
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400">{d.dim}</span>
          <span className="font-display text-xl font-bold text-white">{d.valor}</span>
        </div>
        <div className="h-[3px] w-full bg-white/10">
          <motion.div
            className={`h-full ${i % 2 ? "bg-brand-magenta" : "bg-brand-orange"}`}
            initial={{ width: 0 }}
            whileInView={{ width: `${d.valor}%` }}
            viewport={{ once: true }}
            transition={{ duration: 1.1, delay: 0.12 * i, ease: [0.16, 1, 0.3, 1] }}
          />
        </div>
      </div>
    ))}
    <p className="pt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">{caption}</p>
  </div>
);

export default Radar4D;
